<template>
  <v-container class="pa-2" style="height: calc(100vh - 64px); background-color: #f5f5f5">
    <!-- Scanner Component -->
    <InvoiceScanner
      @code-scanned="handleBarcodeScanned"
      @show-message="showScannerMessage"
      ref="scanner"
    />

    <v-card flat class="d-flex flex-column" style="height: 100%" elevation="10">
      <!-- Header con información de empresa y cliente -->
      <v-card-text class="pb-2">
        <v-row dense>
          <!-- Información de la empresa -->
          <v-col cols="12" md="6">
            <v-card flat elevation="0" height="100%" class="pa-3">
              <div class="text-h6 font-weight-medium mb-2">
                {{ this.$store.state.seller.PartyName }}
              </div>
              <div class="text-body-2 grey--text">
                <div>
                  <!-- {{ get_name_typeId(this.$store.state.seller.typeid) }}: -->
                  {{ this.$store.state.seller.PartyIdentification }}
                </div>
                <div>{{ get_name_city(this.$store.state.seller.CityName) }}</div>
                <div>Email: {{ this.$store.state.seller.email }}</div>
              </div>
            </v-card>
          </v-col>

          <!-- Información del cliente -->
          <v-col cols="12" md="6">
            <v-card flat elevation="0" height="100%" class="pa-3">
              <div class="d-flex justify-space-between align-center mb-2">
                <div class="text-h6 font-weight-medium">
                  {{ this.client.PartyName || "Cliente" }}
                  <!-- <v-chip
                    v-if="esClienteGenerico"
                    x-small
                    outlined
                    color="info"
                    class="ml-2"
                  >
                    {{ tipoClienteChip }}
                  </v-chip> -->
                </div>
                <!-- <v-btn small text color="primary" @click="client_dialog = true">
                  <v-icon left small>mdi-pencil</v-icon>
                  {{ client.PartyName === "CONSUMIDOR FINAL" ? "Cliente" : "Editar" }}
                </v-btn> -->
              </div>
              <div class="text-body-2 grey--text">
                <div>
                  {{ this.client.PartyIdentification || "-" }}
                </div>
                <div>
                  Dirección: {{ this.client.AddressLine || "-" }},
                  {{ get_name_city(this.client.CityName) }}
                </div>
                <div>Email: {{ this.client.client_email || "-" }}</div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <!-- Área de productos (scrollable) -->
      <v-card-text class="flex-grow-1 pa-0 d-flex flex-column">
        <!-- Toolbar de acciones -->
        <v-toolbar
          dense
          flat
          color="grey lighten-4"
          class="flex-shrink-0 py-1"
          height="48"
        >
          <v-btn-toggle dense class="mr-3">
            <v-btn color="teal" @click="manual_product_dialog = true" dark small>
              <v-icon left small>mdi-plus-box</v-icon>
              Manual
            </v-btn>
            <v-btn color="primary" @click="search_dialog = true" small>
              <v-icon left small>mdi-magnify</v-icon>
              Buscar
            </v-btn>
          </v-btn-toggle>

          <v-spacer></v-spacer>

          <v-chip outlined small>
            <v-icon left small>mdi-package-variant</v-icon>
            {{ cart.length }} items
          </v-chip>
        </v-toolbar>

        <!-- Contenedor con scroll para el carrito -->
        <div class="cart-scroll-container">
          <v-list v-if="cart.length > 0" class="pa-0">
            <v-list-item
              v-for="item in cart"
              :key="item.ean"
              class="cart-item"
              @click="editCartItem(item)"
            >
              <v-list-item-content>
                <v-list-item-title class="font-weight-medium mb-1">
                  {{ item.nombre }}
                </v-list-item-title>
                <v-list-item-subtitle class="text-caption">
                  {{ item.marca }} - {{ item.refe }} - {{ item.color }} - {{ item.talla }}
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if="item.note" class="orange--text text-caption">
                  <v-icon x-small class="mr-1">mdi-note</v-icon>
                  {{ item.note }}
                </v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action
                class="flex-row align-center ma-0"
                style="min-width: 450px"
              >
                <!-- Cantidad -->
                <div class="d-flex align-center mx-2" style="min-width: 100px">
                  <v-btn
                    icon
                    x-small
                    @click.stop="
                      item.cantidad > 1 ? item.cantidad-- : null;
                      updateTotal();
                    "
                  >
                    <v-icon x-small>mdi-minus</v-icon>
                  </v-btn>
                  <span
                    class="mx-2 font-weight-medium"
                    style="min-width: 30px; text-align: center"
                  >
                    {{ item.cantidad }}
                  </span>
                  <v-btn
                    icon
                    x-small
                    @click.stop="
                      item.cantidad++;
                      updateTotal();
                    "
                  >
                    <v-icon x-small>mdi-plus</v-icon>
                  </v-btn>
                </div>

                <!-- Precio -->
                <div class="text-right mx-2" style="min-width: 80px">
                  {{ formatCurrency(item.precio) }}
                </div>

                <!-- IVA -->
                <div class="text-right mx-2" style="min-width: 80px">
                  {{ formatCurrency(item.item_tax * item.cantidad) }}
                </div>

                <!-- Total -->
                <div class="text-right mx-2 font-weight-bold" style="min-width: 90px">
                  {{ formatCurrency(item.precio * item.cantidad) }}
                </div>

                <!-- Acciones -->
                <v-btn icon x-small color="error" @click.stop="delete_item(item)">
                  <v-icon x-small>mdi-delete</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>

          <!-- Estado vacío -->
          <div v-else class="text-center py-12">
            <v-icon size="64" color="grey lighten-2">mdi-cart-outline</v-icon>
            <p class="text-h6 grey--text mt-4">Carrito vacío</p>
            <p class="text-body-2 grey--text">Escanea productos o busca en el catálogo</p>
          </div>
        </div>
      </v-card-text>

      <v-divider></v-divider>

      <!-- Footer con totales y botón de pago -->
      <v-card-actions class="pa-3 grey lighten-4">
        <v-row align="center" dense>
          <!-- Totales -->
          <v-col cols="12" md="9">
            <v-row dense>
              <v-col cols="6" md="3">
                <div class="text-center">
                  <div class="text-caption grey--text">Codigo de Barra</div>
                  <div class="font-weight-medium">
                    <v-text-field
                      v-model="sku"
                      dense
                      hide-details
                      outlined
                      placeholder="Escanear o ingresar"
                      @keyup.enter="
                        handleBarcodeScanned(sku);
                        sku = '';
                      "
                    ></v-text-field>
                  </div>
                </div>
              </v-col>
              <v-col cols="6" md="3">
                <div class="text-center">
                  <div class="text-caption grey--text">Subtotal</div>
                  <div class="font-weight-medium">
                    {{ formatCurrency(sumSubtotal(cart, "price_amount")) }}
                  </div>
                </div>
              </v-col>
              <v-col cols="6" md="3">
                <div class="text-center">
                  <div class="text-caption grey--text">Impuestos</div>
                  <div class="font-weight-medium">
                    {{ formatCurrency(sumTaxes(cart, "item_tax")) }}
                  </div>
                </div>
              </v-col>
              <v-col cols="6" md="3">
                <div class="text-center">
                  <div class="text-caption grey--text">Descuentos</div>
                  <div class="font-weight-medium red--text">
                    -{{ formatCurrency(sumDiscount(cart, "discount")) }}
                  </div>
                </div>
              </v-col>
              <!-- <v-col cols="6" md="3">
                <div class="text-center">
                  <div class="text-caption grey--text">Pagado</div>
                  <div class="font-weight-medium success--text">
                    {{ formatCurrency(totals.paid) }}
                  </div>
                </div>
              </v-col> -->
            </v-row>
          </v-col>

          <!-- Botón de pago -->
          <v-col cols="12" md="3">
            <!-- Alertas de validación cuando el botón está deshabilitado -->
            <div v-if="!canOpenCheckout && totals.total > 0" class="mb-2">
              <v-alert dense outlined type="warning" class="pa-2">
                <div class="text-caption">
                  <div v-if="totals.total <= 0">⚠️ Agregue productos al carrito</div>
                  <div v-else-if="needsCompleteClientInfo">
                    ⚠️ Complete información del cliente para facturas > 400€
                  </div>
                  <div v-else-if="hasValidationErrors">
                    ⚠️ Revise los datos críticos del cliente
                  </div>
                  <div v-else>⚠️ Complete los datos requeridos</div>
                </div>
              </v-alert>
            </div>

            <v-btn
              x-large
              :color="getCheckoutButtonColor()"
              block
              @click="handleCheckoutClick"
              :disabled="!canOpenCheckout && !(totals.unpaid === 0 && totals.total > 0)"
            >
              <div class="d-flex flex-column">
                <span class="text-caption">{{ getCheckoutButtonLabel() }}</span>
                <span class="text-h5 font-weight-bold">{{
                  formatCurrency(totals.unpaid > 0 ? totals.unpaid : totals.total)
                }}</span>
              </div>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>

    <!-- Diálogo de búsqueda con tabs -->
    <v-dialog
      v-model="search_dialog"
      max-width="900px"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      scrollable
    >
      <v-card>
        <v-card-title class="pa-0">
          <v-tabs v-model="tab">
            <v-tab>Catálogo</v-tab>
            <v-tab>Departamentos</v-tab>
            <v-tab>Registradora</v-tab>
            <v-spacer></v-spacer>
            <v-btn icon @click="search_dialog = false" class="mr-2">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-tabs>
        </v-card-title>

        <v-card-text class="pa-0">
          <v-tabs-items v-model="tab">
            <!-- Tab Catálogo -->
            <v-tab-item>
              <v-container>
                <v-form @submit.prevent="search_inventory">
                  <v-row dense>
                    <v-col cols="12" md="4">
                      <v-select
                        v-model="filters.field"
                        :items="[
                          'NOMBRE',
                          'CATEGORIA',
                          'GRUPO',
                          'MARCA',
                          'REFE',
                          'COLOR',
                          'TALLA',
                        ]"
                        label="Criterio"
                        outlined
                        dense
                        hide-details
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="filters.value"
                        label="Buscar"
                        outlined
                        dense
                        hide-details
                        clearable
                      />
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-btn
                        block
                        color="primary"
                        type="submit"
                        :loading="loading_status"
                      >
                        Buscar
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>

                <v-data-table
                  :headers="searchHeaders"
                  :items="inventory_lst"
                  :items-per-page="10"
                  class="mt-4"
                  :loading="loading_status"
                >
                  <template v-slot:[`item.nombre`]="{ item }">
                    <div>
                      <div class="font-weight-medium">{{ item.nombre }}</div>
                      <div class="text-caption grey--text">
                        {{ item.marca }} - {{ item.refe }} - {{ item.color }} -
                        {{ item.talla }}
                      </div>
                    </div>
                  </template>

                  <template v-slot:[`item.precio`]="{ item }">
                    <span class="font-weight-bold">{{
                      formatCurrency(item.precio)
                    }}</span>
                  </template>

                  <template v-slot:[`item.actions`]="{ item }">
                    <v-btn small color="primary" @click="add2cart(item)">
                      <v-icon left small>mdi-plus</v-icon>
                      Agregar
                    </v-btn>
                  </template>
                </v-data-table>
              </v-container>
            </v-tab-item>

            <!-- Tab Departamentos -->
            <v-tab-item>
              <ProductPad
                :cartItemTotal="totals.unpaid"
                @product-selected="add2cart"
                @products_dialog="search_dialog = false"
                @fastPayment="fastPayment"
              />
            </v-tab-item>

            <!-- Tab Registradora -->
            <v-tab-item>
              <PLU
                :cartItemTotal="totals.unpaid"
                @product-selected="add2cart"
                @products_dialog="search_dialog = false"
                @fastPayment="fastPayment"
                @cart-show="cartDrawerOpen = !cartDrawerOpen"
              />
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Diálogo de cliente simplificado -->
    <v-dialog v-model="client_dialog" max-width="600px" scrollable persistent>
      <v-card>
        <v-toolbar flat color="primary" dark dense>
          <v-toolbar-title>Información del Cliente</v-toolbar-title>
          <v-spacer></v-spacer>

          <!-- Botones de acceso rápido -->
          <v-btn
            text
            small
            @click="setClienteContado"
            class="mr-2"
            :disabled="loading_status"
          >
            <v-icon left small>mdi-account-cash</v-icon>
            Contado
          </v-btn>

          <v-btn icon @click="client_dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <!-- Alerta informativa para facturas simplificadas -->
        <v-alert v-if="puedeSerFacturaSimplificada" type="info" dense text class="ma-0">
          <v-icon small left>mdi-information</v-icon>
          Importe ≤ 400€: No es obligatorio identificar al cliente (Factura Simplificada)
        </v-alert>

        <v-card-text class="pt-4">
          <!-- Chips de selección rápida -->
          <v-chip-group
            v-model="tipoClienteSeleccionado"
            mandatory
            active-class="primary--text"
            class="mb-4"
          >
            <v-chip value="identificado" @click="limpiarCliente">
              <v-icon left small>mdi-account-check</v-icon>
              Cliente Identificado
            </v-chip>

            <v-chip value="contado" @click="setClienteContado">
              <v-icon left small>mdi-cash</v-icon>
              Cliente Contado
            </v-chip>

            <v-chip value="consumidor" @click="setConsumidorFinal">
              <v-icon left small>mdi-account</v-icon>
              Consumidor Final
            </v-chip>

            <v-chip value="extranjero" @click="setClienteExtranjero">
              <v-icon left small>mdi-earth</v-icon>
              Turista/Extranjero
            </v-chip>
          </v-chip-group>

          <v-divider class="mb-4"></v-divider>

          <v-row dense>
            <!-- Campos del formulario (igual que antes) -->
            <v-col cols="12" sm="5">
              <v-select
                v-model="client.typeid"
                :items="dynamicSettings.documentTypes"
                item-value="code"
                item-text="name"
                label="Tipo de documento"
                outlined
                dense
                :disabled="tipoClienteSeleccionado !== 'identificado'"
              />
            </v-col>
            <v-col cols="12" sm="7">
              <v-text-field
                v-model="client.PartyIdentification"
                label="Número de documento"
                outlined
                dense
                @blur="validarDocumentoAutomatico"
                @keypress="filter"
                :append-icon="validationIcon"
                :success="validationStatus === 'success'"
                :error="validationStatus === 'error'"
                :success-messages="validationMessage"
                :error-messages="validationError"
                :disabled="tipoClienteSeleccionado !== 'identificado'"
              >
                <template v-slot:append-outer>
                  <v-btn
                    icon
                    small
                    @click="searchClientByDocument"
                    :disabled="
                      !client.PartyIdentification ||
                      tipoClienteSeleccionado !== 'identificado'
                    "
                    :loading="searchingClient"
                  >
                    <v-icon small>mdi-magnify</v-icon>
                  </v-btn>
                </template>
              </v-text-field>
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="client.PartyName"
                label="Nombre completo / Razón social"
                outlined
                dense
                :disabled="tipoClienteSeleccionado !== 'identificado'"
              />
            </v-col>

            <v-col cols="12" sm="8">
              <v-text-field
                v-model="client.client_email"
                label="Correo electrónico (opcional)"
                outlined
                dense
                type="email"
              />
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field
                v-model="client.client_phone"
                label="Teléfono (opcional)"
                outlined
                dense
                @keypress="filter"
              />
            </v-col>

            <v-col cols="12" sm="8">
              <v-text-field
                v-model="client.AddressLine"
                label="Dirección"
                outlined
                dense
                :disabled="tipoClienteSeleccionado !== 'identificado'"
              />
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field
                v-model="client.CityName"
                label="Ciudad/Departamento"
                outlined
                dense
                placeholder="Ej: Madrid, Sevilla..."
              />
            </v-col>
          </v-row>

          <!-- Información del tipo de factura que se generará -->
          <v-alert :type="tipoFacturaAlert.type" dense outlined class="mt-3">
            <strong>{{ tipoFacturaAlert.title }}</strong>
            <div class="text-caption">{{ tipoFacturaAlert.message }}</div>
          </v-alert>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="client_dialog = false">Cancelar</v-btn>
          <v-btn color="success" @click="save_client" :disabled="!validarClienteMinimo()">
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Componente de Producto Manual -->
    <ManualProduct
      v-model="manual_product_dialog"
      :product-data="manualProduct"
      :is-editing="editingProduct"
      :editing-product-ean="editingProductEan"
      @product-created="handleProductCreated"
      @product-updated="handleProductUpdated"
      @product-deleted="handleProductDeleted"
    />

    <!-- Componente de Checkout -->
    <!-- Componente de Checkout -->
    <CheckoutComponent
      :visible.sync="payment_dialogo"
      :totalAmount="totals.total"
      :unpaidAmount="totals.unpaid"
      :vendors="vendors"
      :paymentMethods="FP"
      :idList="dynamicSettings.documentTypes"
      :municipalities="[]"
      :companyData="company"
      :clientData="client"
      :validations="validations"
      @doc-type-changed="handleDocTypeChanged"
      @validation-updated="handleValidationUpdated"
      @process-payment="processPayment"
      @open-client-dialog="client_dialog = true"
      @show-message="showMessage"
      @update-client="updateClientFromCheckout"
    />

    <!-- Visualizador de documentos -->
    <docViewer
      :item="item"
      :dialog="dialog"
      :newInvoice="nInvoice"
      @close="dialog = false"
      @refresh="refresh_view()"
    />

    <!-- Snackbars -->
    <v-snackbar v-model="skuError" :timeout="2000" color="error">
      Producto no encontrado
    </v-snackbar>

    <v-snackbar v-model="productAdded" :timeout="1500" color="success">
      Producto agregado
    </v-snackbar>
  </v-container>
</template>

<script>
import { webserver, formatCurrency } from "@/services/webserver.js";
import createClient from "@/utils/createClient.js";
import createPayment from "@/utils/createPayment.js";
import docViewer from "@/components/doc_viewer.vue";
import createDoc from "@/utils/create_doc.js";
import settings from "@/utils/settings.js";
import createCompany from "@/utils/createCompany.js";
import CheckoutComponent from "@/components/checkout.vue";
import PLU from "@/views/pos/PLUD.vue";
import ProductPad from "@/views/pos/ProductPad.vue";
import ValidadorNIF from "@/services/validador-nif-es.js";
// Componente del scanner
import InvoiceScanner from "./components/InvoiceScanner.vue";
// Componente de producto manual
import ManualProduct from "./components/ManualProduct.vue";
import countryUtils from "../../utils/countryUtils.js";

export default {
  name: "InvoiceE",
  components: {
    docViewer,
    CheckoutComponent,
    PLU,
    ProductPad,
    InvoiceScanner,
    ManualProduct,
  },

  data() {
    const settingsData = settings();
    return {
      setting: settingsData,

      manual_product_dialog: false,
      editingProduct: false,
      editingProductEan: null, // ✅ Usar EAN en lugar de índice

      manualProduct: {
        nombre: "",
        descripcion: "",
        note: "",
        cantidad: 1,
        precio: "",
        descuento: 0,
        tax: 21,
        manual: true,
      },
      dynamicSettings: {
        documentTypes: [],
        departments: [],
        liabilityTypes: [],
        organizationTypes: [],
        regimeTypes: [],
        vatRates: [],
      },

      tipoClienteSeleccionado: "identificado",
      clientesGenericos: {
        contado: {
          PartyIdentification: "99999999R",
          PartyName: "CLIENTE CONTADO",
          typeid: "DNI",
          AddressLine: "Venta mostrador",
          client_email: "",
          client_phone: "",
        },
        consumidor: {
          PartyIdentification: "222222222222",
          PartyName: "CONSUMIDOR FINAL",
          typeid: "CC",
          AddressLine: "Consumidor Final",
          client_email: "",
          client_phone: "",
        },
        extranjero: {
          PartyIdentification: "X0000000T",
          PartyName: "CLIENTE EXTRANJERO",
          typeid: "PAS",
          AddressLine: "Turista",
          client_email: "",
          client_phone: "",
        },
      },

      validationIcon: "",
      validationStatus: "",
      validationMessage: "",
      validationError: "",
      searchingClient: false,
      tab: 0,
      loading_status: false,
      skuError: false,
      productAdded: false,

      // Diálogos
      search_dialog: false,
      client_dialog: false,
      payment_dialogo: false,
      dialog: false,

      // Datos principales
      company: createCompany(),
      store: createClient(),
      client: createClient(),
      cart: [],
      payments: [],

      // Búsqueda
      sku: "",
      filters: { field: "NOMBRE", value: "" },
      inventory_lst: [],

      // Vendedores
      vendors: [],
      vendor: null,

      // Totales
      totals: { qty: 0, total: 0, tax: 0, paid: 0, unpaid: 0 },

      // Opciones
      bags: 0,
      discount: null,

      // Pago
      pay_mode: { codigo: "01", valor: "EFECTIVO" },
      payment: createPayment(),

      // Configuraciones
      FP: [],
      CT: [],
      MR: [],
      colors: [],
      seller: null,

      // Documento
      item: createDoc(),
      nInvoice: false,
      doctype: "invoice",

      // IDs españoles
      // id_lst: settingsData["type_document_identifications"] || [],

      // Headers
      headers_cart: [
        { text: "Descripción", value: "refe", width: "40%" },
        { text: "Cant.", value: "cantidad", align: "center", width: "10%" },
        { text: "Precio", value: "precio", align: "right", width: "15%" },
        { text: "IVA", value: "item_tax", align: "right", width: "15%" },
        { text: "Total", value: "subtotal", align: "right", width: "15%" },
        { text: "", value: "actions", align: "center", sortable: false, width: "5%" },
      ],

      searchHeaders: [
        { text: "Producto", value: "nombre", width: "40%" },
        { text: "Categoría", value: "categoria" },
        { text: "Stock", value: "cantidad", align: "center" },
        { text: "Precio", value: "precio", align: "right" },
        { text: "", value: "actions", align: "center", sortable: false },
      ],

      // Validaciones
      validations: [
        { status: false, label: "Nombre del cliente requerido" },
        { status: false, label: "Correo electrónico requerido" },
        { status: false, label: "Documento de identificación requerido" },
        { status: false, label: "Tipo de documento requerido" },
        { status: true, label: "Vendedor requerido" },
        { status: false, label: "Requiere Factura Electrónica" },
        { status: false, label: "Valor" },
        { status: false, label: "Ciudad requerida" },
      ],
    };
  },

  mounted() {
    this.store = window.store;
    this.get_data_company();
    this.get_vendors();
    this.FP = window.settings.FP || [];
    this.CT = window.settings.CATEGORIA || [];
    this.MR = window.settings.MARCA || [];
    this.colors = window.settings.COLOR || [];
    this.seller = window.seller;
    this.loadDynamicSettings();

    // Establecer cliente por defecto como Consumidor Final
    this.client = { ...this.clientesGenericos.consumidor };
    this.tipoClienteSeleccionado = "consumidor";

    // Eliminar los event listeners del scanner ya que están en el componente hijo

    this.$root.$on("edit-cart-item", (item) => {
      const index = this.cart.findIndex((cartItem) => cartItem.ean === item.ean);
      if (index !== -1) {
        this.editCartItem(item, index);
      }
    });
  },

  beforeDestroy() {
    // Limpiar listeners
    this.$root.$off("edit-cart-item");
  },

  methods: {
    formatCurrency,

    loadDynamicSettings() {
      try {
        console.log("🌍 Cargando configuraciones dinámicas...");

        // Cargar settings dinámicos
        this.setting = settings();

        // Cargar configuraciones específicas por país
        this.dynamicSettings = {
          documentTypes: countryUtils.getDocumentTypes(),
          departments: countryUtils.getDepartments(),
          liabilityTypes: countryUtils.getLiabilityTypes(),
          organizationTypes: countryUtils.getOrganizationTypes(),
          regimeTypes: countryUtils.getRegimeTypes(),
          vatRates: countryUtils.getVatRates(),
        };

        // Cargar países disponibles
        this.availableCountries = countryUtils.getAvailableCountries();

        // 🇨🇴 COLOMBIA: Actualizar clientes genéricos según el país
        const countryCode = countryUtils.getCurrentCountryCode();
        if (countryCode === "CO") {
          this.clientesGenericos = {
            contado: {
              PartyIdentification: "222222222222",
              PartyName: "CLIENTE CONTADO",
              typeid: "CC",
              AddressLine: "Venta mostrador",
              client_email: "",
              client_phone: "",
            },
            consumidor: {
              PartyIdentification: "222222222222",
              PartyName: "CONSUMIDOR FINAL",
              typeid: "CC",
              AddressLine: "Consumidor Final",
              client_email: "",
              client_phone: "",
            },
            extranjero: {
              PartyIdentification: "11111111",
              PartyName: "CLIENTE EXTRANJERO",
              typeid: "CE",
              AddressLine: "Turista",
              client_email: "",
              client_phone: "",
            },
          };
        }

        console.log("✅ Configuraciones dinámicas cargadas:", {
          country: countryUtils.getCurrentCountryCode(),
          documentsCount: this.dynamicSettings.documentTypes.length,
          departmentsCount: this.dynamicSettings.departments.length,
        });
      } catch (error) {
        console.error("❌ Error cargando configuraciones dinámicas:", error);
        this.$store.commit("setSnackbar", {
          text: "Error cargando configuraciones del país",
          color: "error",
          timeout: 3000,
        });
      }
    },
    // === MÉTODOS DEL MANUAL PRODUCT ===

    /**
     * Manejar creación de producto desde el componente hijo
     */
    handleProductCreated(product) {
      console.log("📦 Producto creado:", product);
      this.add2cart(product);
      this.showProductMessage(`✓ ${product.nombre} añadido al carrito`, "success");
    },

    /**
     * Manejar actualización de producto desde el componente hijo
     */
    handleProductUpdated(data) {
      const { product, ean } = data;
      console.log("✏️ Producto actualizado:", product, "con EAN:", ean);

      // ✅ Buscar por EAN en lugar de usar índice
      const index = this.cart.findIndex((item) => item.ean === ean);
      if (index === -1) {
        this.showProductMessage("Error: Producto no encontrado en el carrito", "error");
        console.error("❌ Producto con EAN no encontrado:", ean);
        return;
      }

      // Actualizar el producto en el carrito
      const updatedProduct = {
        ...this.cart[index],
        nombre: product.nombre,
        note: product.note,
        cantidad: product.cantidad,
        precio: parseFloat(product.precio),
        descuento: parseFloat(product.descuento) || 0,
        tax: product.tax,
      };

      // Si cambió el descuento, recalcular
      if (updatedProduct.descuento > 0) {
        const discount = (updatedProduct.precio * updatedProduct.descuento) / 100;
        updatedProduct.discount = discount;
        updatedProduct.precio = updatedProduct.precio - discount;
      } else {
        updatedProduct.discount = 0;
      }

      // ✅ CORRECCIÓN: Recalcular impuesto después de aplicar el descuento
      const tax_value = parseFloat(updatedProduct.tax) / 100 + 1;
      updatedProduct.price_amount = Math.round(parseFloat(updatedProduct.precio) / tax_value * 100) / 100;
      updatedProduct.item_tax = updatedProduct.precio - updatedProduct.price_amount;

      // Actualizar en el carrito
      this.$set(this.cart, index, updatedProduct);
      this.updateTotal();
      this.showProductMessage(`✓ ${updatedProduct.nombre} actualizado`, "success");
    },

    /**
     * Manejar eliminación de producto desde el componente hijo
     */
    handleProductDeleted(data) {
      const { ean, product } = data;
      console.log("🗑️ Producto eliminado:", product, "con EAN:", ean);

      // ✅ Buscar por EAN en lugar de usar índice
      const index = this.cart.findIndex((item) => item.ean === ean);
      if (index === -1) {
        this.showProductMessage("Error: Producto no encontrado en el carrito", "error");
        console.error("❌ Producto con EAN no encontrado:", ean);
        return;
      }

      const productName = product.nombre || "Producto";
      this.cart.splice(index, 1);
      this.updateTotal();
      this.showProductMessage(`✗ ${productName} eliminado del carrito`, "info");
    },

    /**
     * Mostrar mensajes desde el componente de producto manual
     */
    showProductMessage(text, color = "info") {
      this.$store.commit("setSnackbar", {
        text,
        color,
        timeout: 2000,
      });
    },

    // === MÉTODOS DEL SCANNER (nuevos) ===

    /**
     * Manejar código escaneado desde el componente hijo
     */
    handleBarcodeScanned(code) {
      console.log("📷 Código escaneado:", code);
      this.get_barcode(code);
    },

    /**
     * Mostrar mensajes desde el componente scanner
     */
    showScannerMessage(message) {
      this.$store.commit("setSnackbar", message);
    },

    /**
     * Método público para resetear el scanner si es necesario
     */
    resetScanner() {
      if (this.$refs.scanner) {
        this.$refs.scanner.resetScanner();
      }
    },

    /**
     * Buscar producto por código de barras (llamado desde el scanner)
     */
    get_barcode(code) {
      this.loading_status = true;
      const qry = {
        store: window.store.store_id,
        dbSearch: "items",
        filters: [
          {
            field: "id_pos",
            operator: "=",
            value: window.store.store_id,
          },
          {
            field: "ean",
            operator: "=",
            value: code,
          },
        ],
      };

      webserver("get_catalog", qry, (data) => {
        this.loading_status = false;
        if (data[0]) {
          this.add2cart(data[0]);
        } else {
          this.skuError = true;
        }
      });
    },

    // === MÉTODOS EXISTENTES ===
    updateClientFromCheckout(clientData) {
      this.client = { ...clientData };
      console.log("Cliente actualizado desde checkout:", this.client);
    },
    openCheckout() {
      // Validaciones adicionales antes de abrir checkout
      if (!this.canOpenCheckout) {
        this.showValidationMessage();
        return;
      }

      // Asegurar que el cliente esté sincronizado
      console.log("Abriendo checkout con cliente:", this.client);

      this.payment_dialogo = true;
    },

    showValidationMessage() {
      let message = "Complete los datos requeridos";
      let color = "warning";

      const countryCode = countryUtils.getCurrentCountryCode();

      if (this.totals.total <= 0) {
        message = "Agregue productos al carrito";
      } else if (countryCode !== "CO" && this.needsCompleteClientInfo) {
        // Solo mostrar mensaje de 400€ en España
        message =
          "Para importes superiores a 400€ debe identificar completamente al cliente";
        color = "error";
      } else if (this.hasValidationErrors) {
        message = "Revise y complete los datos críticos del cliente";
      }

      this.$store.commit("setSnackbar", {
        text: message,
        color: color,
        timeout: 4000,
      });
    },
    removeProductFromCart() {
      // Validar que el índice sea válido y el producto exista
      if (this.editingIndex < 0 || this.editingIndex >= this.cart.length) {
        this.$store.commit("setSnackbar", {
          text: "Error: Producto no encontrado en el carrito",
          color: "error",
          timeout: 2000,
        });
        this.closeManualProduct();
        return;
      }

      // Obtener el nombre del producto antes de eliminarlo
      const product = this.cart[this.editingIndex];
      const productName = product ? product.nombre || "Producto" : "Producto";

      // Eliminar el producto del carrito
      this.cart.splice(this.editingIndex, 1);

      this.$store.commit("setSnackbar", {
        text: `✗ ${productName} eliminado del carrito`,
        color: "info",
        timeout: 2000,
      });

      this.closeManualProduct();
      this.updateTotal();
    },

    editCartItem(item, index) {
      // Si se llama desde la tabla, el index viene en item
      if (typeof item === "object" && index === undefined) {
        index = this.cart.findIndex((cartItem) => cartItem.ean === item.ean);
      }

      // Validar que el índice sea válido
      if (index < 0 || index >= this.cart.length) {
        console.error("❌ Índice inválido para editar producto:", index);
        return;
      }

      // Clonar el item para edición
      // Restaurar el precio original (antes del descuento) para el diálogo
      const precioOriginal = item.discount > 0
        ? item.precio + item.discount
        : item.precio;

      this.manualProduct = {
        ...item,
        precio: precioOriginal,
        note: item.note || "",
        descuento: Math.round(item.descuento || 0),
        tax: Math.round(item.tax || 0),
      };

      this.editingProduct = true;
      this.editingProductEan = item.ean; // ✅ Usar EAN en lugar de índice
      this.manual_product_dialog = true;
    },
    createManualProduct() {
      const now = Date.now();
      const price = parseFloat(this.manualProduct.precio);
      const qty = parseInt(this.manualProduct.cantidad);
      const discountPercent = parseFloat(this.manualProduct.descuento) || 0;

      // Calcular descuento
      const discountAmount = (price * discountPercent) / 100;
      const priceAfterDiscount = price - discountAmount;

      // Calcular precios con impuestos
      const taxRate = parseFloat(this.manualProduct.tax) / 100 + 1;
      const priceWithoutTax = Math.round((priceAfterDiscount / taxRate) * 100) / 100;
      const taxAmount = priceAfterDiscount - priceWithoutTax;

      return {
        // Identificadores únicos
        id_pos: window.store.store_id,
        sku: `2-${now}`,
        ean: `2-${now}`,

        // Información del producto
        nombre: this.manualProduct.nombre.toUpperCase(),
        descripcion: this.manualProduct.descripcion,
        note: this.manualProduct.note, // NUEVO: incluir nota
        categoria: "PRODUCTO MANUAL",
        grupo: "MANUAL",
        marca: "GENÉRICO",
        refe: `REF-${now}`,
        color: "",
        talla: "",

        // Cantidades y precios
        cantidad: qty,
        costo: "0.00",
        precio: priceAfterDiscount,
        price_amount: priceWithoutTax,
        item_tax: taxAmount,
        precioB: "0.00",
        precioC: "0.00",
        descuento: discountPercent,
        discount: discountAmount,

        // Impuestos
        tax: this.manualProduct.tax,

        // Información adicional
        store_name: this.$store.state.seller.PartyName,
        manual: true,
        isExpanded: false,
      };
    },

    addManualProduct() {
      if (this.$refs.manualProductForm.validate()) {
        const product = this.createManualProduct();

        // Añadir al carrito usando el mismo método que otros productos
        this.add2cart(product);

        // Mostrar confirmación
        this.$store.commit("setSnackbar", {
          text: `✓ ${product.nombre} añadido al carrito`,
          color: "success",
          timeout: 2000,
        });

        // Cerrar diálogo y limpiar
        this.closeManualProduct();
      }
    },

    closeManualProduct() {
      this.manual_product_dialog = false;
      // Limpiar formulario después de cerrar
      setTimeout(() => {
        this.manualProduct = {
          nombre: "",
          descripcion: "",
          note: "",
          cantidad: 1,
          precio: "",
          descuento: 0,
          tax: 21,
          manual: true,
        };
        this.editingProduct = false;
        this.editingProductEan = null; // ✅ Limpiar EAN
        if (this.$refs.manualProductForm) {
          this.$refs.manualProductForm.resetValidation();
        }
      }, 300);
    },

    // Helpers para navegación con Enter
    focusNext(refName) {
      this.$nextTick(() => {
        if (this.$refs[refName]) {
          this.$refs[refName].focus();
        }
      });
    },

    // Filtros para inputs numéricos
    filterNumbers(evt) {
      evt = evt ? evt : window.event;
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      }
    },

    filterDecimals(evt) {
      evt = evt ? evt : window.event;
      const charCode = evt.which ? evt.which : evt.keyCode;
      const value = evt.target.value;

      // Permitir números
      if (charCode >= 48 && charCode <= 57) return true;

      // Permitir un solo punto decimal
      if (charCode === 46 && value.indexOf(".") === -1) return true;

      // Permitir coma y convertir a punto
      if (charCode === 44) {
        if (value.indexOf(".") === -1 && value.indexOf(",") === -1) {
          evt.target.value = value + ".";
        }
        evt.preventDefault();
        return false;
      }

      evt.preventDefault();
      return false;
    },
    setClienteContado() {
      this.tipoClienteSeleccionado = "contado";
      this.client = {
        ...this.clientesGenericos.contado,
        CityName: this.company.city_code || this.client.CityName,
      };
      this.limpiarValidacion();
    },

    setConsumidorFinal() {
      this.tipoClienteSeleccionado = "consumidor";
      this.client = {
        ...this.clientesGenericos.consumidor,
        CityName: this.company.city_code || this.client.CityName,
      };
      this.limpiarValidacion();
    },

    setClienteExtranjero() {
      this.tipoClienteSeleccionado = "extranjero";
      this.client = {
        ...this.clientesGenericos.extranjero,
        CityName: this.company.city_code || this.client.CityName,
      };
      this.limpiarValidacion();
    },

    limpiarCliente() {
      this.tipoClienteSeleccionado = "identificado";
      this.client = createClient();
      this.client.CityName = this.company.city_code || this.client.CityName;
      this.limpiarValidacion();
    },

    searchClientByDocument() {
      if (!this.client.PartyIdentification) {
        this.$store.commit("setSnackbar", {
          text: "Ingrese un número de documento para buscar",
          color: "warning",
          timeout: 2000,
        });
        return;
      }

      this.searchingClient = true;

      const qry = {
        store: window.store.store_id,
        table: "clients",
        filters: [
          {
            field: "PartyIdentification",
            operator: "=",
            value: this.client.PartyIdentification,
          },
        ],
      };

      webserver("get_dataTable", qry, (data) => {
        this.searchingClient = false;

        if (data.length > 0) {
          const foundClient = data[0];

          // Actualizar datos del cliente. Si el cliente en BD tiene typeid vacio,
          // NO sobrescribir lo que el usuario eligio en el select.
          this.client = {
            ...this.client,
            PartyName: foundClient.PartyName || "",
            typeid: foundClient.typeid || this.client.typeid || "DNI",
            client_email: foundClient.client_email || "",
            client_phone: foundClient.client_phone || "",
            AddressLine: foundClient.AddressLine || "",
            CityName: foundClient.CityName || this.company.city_code || "",
          };

          // Actualizar tipo de cliente según los datos encontrados
          if (foundClient.tipo_cliente) {
            this.tipoClienteSeleccionado = foundClient.tipo_cliente;
          } else {
            // Detectar tipo según los datos
            if (foundClient.PartyIdentification === "99999999R") {
              this.tipoClienteSeleccionado = "contado";
            } else if (foundClient.PartyIdentification === "X0000000T") {
              this.tipoClienteSeleccionado = "extranjero";
            } else if (
              !foundClient.PartyIdentification ||
              foundClient.PartyName === "CONSUMIDOR FINAL"
            ) {
              this.tipoClienteSeleccionado = "consumidor";
            } else {
              this.tipoClienteSeleccionado = "identificado";
            }
          }

          this.$store.commit("setSnackbar", {
            text: `Cliente encontrado: ${foundClient.PartyName}`,
            color: "success",
            timeout: 2000,
          });

          // Validar el documento automáticamente
          this.validarDocumentoAutomatico();
        } else {
          this.$store.commit("setSnackbar", {
            text: "Cliente no encontrado en la base de datos",
            color: "info",
            timeout: 3000,
          });
        }
      });
    },

    validarClienteMinimo() {
      // Para consumidor final en facturas simplificadas no necesita validación
      if (
        this.tipoClienteSeleccionado === "consumidor" &&
        this.puedeSerFacturaSimplificada
      ) {
        return true;
      }

      // Para otros casos, al menos necesita nombre
      return this.client.PartyName && this.client.PartyName.trim().length > 0;
    },
    validarDocumentoAutomatico() {
      const countryCode = countryUtils.getCurrentCountryCode();

      if (countryCode === "CO") {
        // 🇨🇴 COLOMBIA: Usar validación colombiana
        if (
          !this.client.PartyIdentification ||
          this.client.PartyIdentification.length < 6
        ) {
          this.limpiarValidacion();
          return;
        }

        const resultado = this.validarDocumentoColombia(
          this.client.PartyIdentification,
          this.client.typeid
        );

        if (resultado.valido) {
          this.validationIcon = "mdi-check-circle";
          this.validationStatus = "success";
          this.validationMessage = `${this.client.typeid} válido`;
          this.validationError = "";
        } else {
          this.validationIcon = "mdi-alert-circle-outline";
          this.validationStatus = "";
          this.validationMessage = "";
          this.validationError = "";
        }
      } else {
        // 🇪🇸 ESPAÑA: Usar validación española original
        if (
          !this.client.PartyIdentification ||
          this.client.PartyIdentification.length < 9
        ) {
          this.limpiarValidacion();
          return;
        }

        const resultado = this.validarDocumentoEspanol(this.client.PartyIdentification);

        if (resultado.valido) {
          // Documento válido
          this.validationIcon = "mdi-check-circle";
          this.validationStatus = "success";
          this.validationMessage = `${resultado.tipoDetectado} válido`;
          this.validationError = "";

          // Auto-seleccionar el tipo correcto
          if (resultado.tipoDetectado === "CIF") {
            const letra = this.client.PartyIdentification.charAt(0);
            if (letra === "A" || letra === "B") {
              this.client.typeid = letra;
            } else {
              this.client.typeid = "VAT"; // Otros CIF
            }
          } else if (resultado.tipoDetectado === "NIE") {
            this.client.typeid = "NIE";
          } else if (resultado.tipoDetectado === "DNI") {
            this.client.typeid = "DNI";
          }

          // Si es empresa, intentar VIES en segundo plano
          if (resultado.tipoDetectado === "CIF") {
            this.consultarVIESBackground();
          }
        } else {
          // Documento no válido - solo advertencia
          this.validationIcon = "mdi-alert-circle-outline";
          this.validationStatus = "";
          this.validationMessage = "";
          this.validationError = "";
        }
      }

      // ✅ ARREGLO: Forzar actualización después de validación
      this.$nextTick(() => {
        this.$forceUpdate();
        console.log("✅ Documento validado, actualizando estado...");
      });
    },
    consultarVIESBackground() {
      fetch("https://ai-bos.co/ws/vies/index.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ nif: this.client.PartyIdentification }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.success && data.valid) {
            this.validationMessage = "CIF válido - Verificado en VIES";
            this.validationIcon = "mdi-check-decagram";
          }
        })
        .catch(() => {
          // Ignorar errores de VIES
        });
    },
    limpiarValidacion() {
      this.validationIcon = "";
      this.validationStatus = "";
      this.validationMessage = "";
      this.validationError = "";
    },
    validarDocumentoEspanol(documento) {
      if (!documento) return { valido: false };

      documento = documento.toUpperCase().trim();

      // Patrones de validación
      const patrones = {
        DNI: /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKE]$/,
        NIE: /^[XYZ][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]$/,
        CIF: /^[ABCDEFGHJNPQRSUVW][0-9]{7}[0-9A-J]$/,
      };

      // Detectar tipo
      let tipo = null;
      if (patrones.DNI.test(documento)) {
        tipo = "DNI";
      } else if (patrones.NIE.test(documento)) {
        tipo = "NIE";
      } else if (patrones.CIF.test(documento)) {
        tipo = "CIF";
      }

      if (!tipo) {
        return { valido: false, tipoDetectado: null };
      }

      // Validar según el tipo
      let valido = false;

      if (tipo === "DNI") {
        const numero = parseInt(documento.substr(0, 8));
        const letra = documento.substr(8, 1);
        const letrasValidas = "TRWAGMYFPDXBNJZSQVHLCKE";
        valido = letra === letrasValidas[numero % 23];
      } else if (tipo === "NIE") {
        let numero = documento;
        numero = numero.replace("X", "0").replace("Y", "1").replace("Z", "2");
        numero = parseInt(numero.substr(0, 8));
        const letra = documento.substr(8, 1);
        const letrasValidas = "TRWAGMYFPDXBNJZSQVHLCKE";
        valido = letra === letrasValidas[numero % 23];
      } else if (tipo === "CIF") {
        // Validación simplificada de CIF
        valido = true; // Por ahora aceptamos todos los CIF con formato correcto
      }

      return {
        valido: valido,
        tipoDetectado: tipo,
      };
    },

    validarDocumentoColombia(documento, tipeid) {
      if (!documento) return { valido: false };

      documento = documento.toString().trim();

      // Validaciones específicas para Colombia
      if (tipeid === "CC") {
        // Cédula de Ciudadanía: 7-10 dígitos
        const cedulaPattern = /^[0-9]{7,10}$/;
        return { valido: cedulaPattern.test(documento) };
      } else if (tipeid === "NIT") {
        // NIT: 9-10 dígitos con dígito de verificación
        const nitPattern = /^[0-9]{9,10}$/;
        return { valido: nitPattern.test(documento) };
      } else if (tipeid === "CE") {
        // Cédula de Extranjería: números y letras
        const cePattern = /^[A-Z0-9]{6,12}$/;
        return { valido: cePattern.test(documento.toUpperCase()) };
      } else if (tipeid === "TI") {
        // Tarjeta de Identidad: números
        const tiPattern = /^[0-9]{10,11}$/;
        return { valido: tiPattern.test(documento) };
      } else if (tipeid === "PP") {
        // Pasaporte: letras y números
        const ppPattern = /^[A-Z0-9]{6,12}$/;
        return { valido: ppPattern.test(documento.toUpperCase()) };
      }

      // Por defecto, aceptar cualquier documento
      return { valido: true };
    },

    // Cálculos
    sumField(fld, key) {
      return fld.reduce((a, b) => parseFloat(a) + (parseFloat(b[key]) || 0), 0);
    },

    sumTaxes(fld, key) {
      return fld.reduce(
        (a, b) => parseFloat(a) + (parseFloat(b[key]) * parseFloat(b["cantidad"]) || 0),
        0
      );
    },

    sumSubtotal(fld, key) {
      return fld.reduce(
        (a, b) =>
          parseFloat(a) +
          ((parseFloat(b[key]) - parseFloat(b["discount"])) * parseFloat(b["cantidad"]) ||
            0),
        0
      );
    },

    sumDiscount(fld, key) {
      return fld.reduce(
        (a, b) => parseFloat(a) + (parseFloat(b[key]) * parseFloat(b["cantidad"]) || 0),
        0
      );
    },

    // Datos iniciales
    get_data_company() {
      var qry = {
        store: window.store.store_id,
        table: "f_companies",
        filters: [
          {
            field: "store_code",
            operator: "=",
            value: window.store.store_id,
          },
          {
            field: "PartyIdentification",
            operator: "=",
            value: window.store.store_business_id,
          },
        ],
      };

      webserver("get_dataTable", qry, (data) => {
        if (data.length > 0) {
          this.company = data[0];
          this.client.CityName = this.company.city_code;
        }
      });
    },

    get_vendors() {
      var qry = {
        store: window.store.store_id,
      };
      webserver("vendors", qry, (data) => {
        data.forEach((itm) => {
          itm.nombre = itm.nombre.toUpperCase();
        });
        this.vendors = data;
      });
    },

    // Búsqueda de productos
    get_product(e) {
      e.preventDefault();
      if (!this.sku) return;

      this.loading_status = true;
      var qry = {
        store: window.store.store_id,
        dbSearch: "inventory",
        filters: [
          {
            field: "id_pos",
            operator: "=",
            value: window.store.store_id,
          },
          {
            field: "ean",
            operator: "=",
            value: this.sku,
          },
        ],
      };

      this.sku = "";
      webserver("get_catalog", qry, (data) => {
        this.loading_status = false;
        if (data[0]) {
          this.add2cart(data[0]);
        } else {
          this.skuError = true;
        }
      });
    },

    search_inventory(e) {
      e.preventDefault();
      if (!this.filters.value) return;

      this.loading_status = true;
      var qry = {
        store: window.store.store_id,
        dbSearch: "inventory",
        filters: [
          {
            field: "id_pos",
            operator: "=",
            value: window.store.store_id,
          },
          {
            field: "cantidad",
            operator: ">",
            value: 0,
          },
          {
            field: this.filters.field,
            operator: " LIKE ",
            value: this.filters.value,
          },
        ],
      };

      webserver("get_catalog", qry, (data) => {
        this.loading_status = false;
        this.inventory_lst = data;
      });
    },

    // Carrito
    add2cart(e) {
      const nItm = { ...e };
      // Si el producto ya tiene nota, preservarla
      if (!nItm.note) {
        nItm.note = "";
      }
      nItm.precio = parseFloat(nItm.precio);
      nItm.cantidad = 1;
      nItm.isExpanded = false;

      if (!nItm.tax) nItm.tax = 19;

      var tax_value = parseFloat(nItm.tax) / 100 + 1;

      if (parseInt(nItm.descuento) > 0 && parseInt(nItm.descuento) <= 100) {
        var factor = parseInt(nItm.descuento) / 100;
        nItm.discount = Math.round(nItm.precio * factor);
      } else {
        nItm.discount = parseInt(nItm.descuento) || 0;
      }

      nItm.precio = nItm.precio - nItm.discount;
      nItm.price_amount = Math.round(parseFloat(nItm.precio) / tax_value);
      nItm.item_tax = nItm.precio - nItm.price_amount;

      var index = this.cart.findIndex((itm) => itm.ean === nItm.ean);
      if (index === -1) {
        this.cart.push(nItm);
      } else {
        this.cart[index].cantidad++;
      }

      this.productAdded = true;
      this.updateTotal();
      this.setSku();

      // Permitir añadir nota rápida con Shift+Enter después de escanear
      if (this.lastScannedItem === nItm.ean) {
        this.$nextTick(() => {
          const index = this.cart.length - 1;
          if (this.quickNoteMode) {
            this.editCartItem(this.cart[index], index);
            this.quickNoteMode = false;
          }
        });
      }
    },

    delete_item(e) {
      var index = this.cart.indexOf(e);
      if (index !== -1) {
        this.cart.splice(index, 1);
      }
      this.updateTotal();
    },

    toggleItemExpansion(item) {
      item.isExpanded = !item.isExpanded;
      this.cart.forEach((cartItem) => {
        if (cartItem !== item) {
          cartItem.isExpanded = false;
        }
      });
    },

    // Descuentos
    itemdiscountApply(e) {
      if (e.keyCode !== 13) return;

      var item = this.cart.find((i) => i.isExpanded);
      if (!item) return;

      item.descuento = parseFloat(item.descuento);
      if (item.discount && item.discount > 0) {
        item.precio = item.precio + item.discount;
      }
      var factor = parseFloat(item.descuento) / 100;
      item.discount = Math.round(item.precio * factor);
      item.precio = parseInt(item.precio - item.discount);

      this.updateTotal();
    },

    // Cliente


    save_client() {
      // Validar antes de guardar
      if (!this.validarClienteMinimo()) {
        this.$store.commit("setSnackbar", {
          text: "Por favor complete los datos mínimos del cliente",
          color: "warning",
        });
        return;
      }

      var qry = {
        store: window.store.store_id,
        party: {
          ...this.client,
          tipo_cliente: this.tipoClienteSeleccionado,
          es_generico: this.tipoClienteSeleccionado !== "identificado",
        },
      };

      webserver("put_client_info", qry, () => {
        this.client_dialog = false;

        // ✅ ARREGLO: Forzar actualización de validaciones después de guardar
        this.$nextTick(() => {
          // Forzar recálculo de computed properties
          this.$forceUpdate();
          console.log("🔄 Cliente guardado y validaciones actualizadas:", this.client);
          console.log("🔄 ¿Es genérico ahora?:", this.esClienteGenerico);
          console.log("🔄 ¿Puede abrir checkout?:", this.canOpenCheckout);
        });

        // Mensaje según el tipo
        let mensaje = "Cliente guardado";
        if (this.tipoClienteSeleccionado === "contado") {
          mensaje = "Configurado como Cliente Contado";
        } else if (this.tipoClienteSeleccionado === "consumidor") {
          mensaje = "Configurado como Consumidor Final";
        } else if (this.tipoClienteSeleccionado === "extranjero") {
          mensaje = "Configurado como Cliente Extranjero";
        } else if (!this.esClienteGenerico) {
          mensaje = "Cliente identificado correctamente";
        }

        this.$store.commit("setSnackbar", {
          text: mensaje,
          color: "success",
        });
      });
    },

    // Modificar validateID para que funcione sin el botón RUT
    validateID() {
      // Solo validar números
      // La validación del documento se hace en @blur
    },
    validateRealTime() {
      if (!this.client.PartyIdentification || this.client.PartyIdentification.length < 9)
        return;

      const validacion = ValidadorNIF.validar(this.client.PartyIdentification);

      // Mostrar indicador visual sin interrumpir
      if (validacion.valid) {
        // Podríamos añadir un icono de check verde al lado del campo
        this.validationIcon = "mdi-check-circle";
        this.validationColor = "success";
      } else {
        // No mostrar error mientras escribe, solo cuando termina
        this.validationIcon = "";
        this.validationColor = "";
      }
    },

    clearClient() {
      // En lugar de vaciar, establecer Consumidor Final
      this.client = {
        ...this.clientesGenericos.consumidor,
        CityName: this.company.city_code || this.client.CityName,
      };
      this.tipoClienteSeleccionado = "consumidor";
      this.limpiarValidacion();
    },

    // Checkout handlers
    handleDocTypeChanged(data) {
      this.doctype = data.doctype;
    },

    handleValidationUpdated(data) {
      this.validations = data.validations;
      return data.isValid;
    },

    showMessage(message) {
      this.$store.commit("setSnackbar", message);
    },

    processPayment(paymentData) {
      console.log("=== RECIBIENDO PAGO EN INVOICEE ===");
      console.log("paymentData recibido:", paymentData);

      const { payment, pay_mode, vendor, client, doctype } = paymentData;

      // Validar datos recibidos
      if (!payment || !pay_mode || !vendor) {
        console.error("❌ Datos de pago incompletos:", { payment, pay_mode, vendor });
        this.$store.commit("setSnackbar", {
          text: "Error: Datos de pago incompletos",
          color: "error",
          timeout: 3000,
        });
        return;
      }

      // Validar valor del pago
      if (!payment.payment_value || payment.payment_value <= 0) {
        console.error("❌ Valor de pago inválido:", payment.payment_value);
        this.$store.commit("setSnackbar", {
          text: "Error: Valor de pago inválido",
          color: "error",
          timeout: 3000,
        });
        return;
      }

      console.log("✅ Datos validados, procesando pago...");

      // Actualizar datos del componente
      this.vendor = vendor;
      this.doctype = doctype;
      this.client = { ...client };

      // Crear el objeto de pago
      let newPayment;

      if (pay_mode.codigo === "01") {
        // Pago en efectivo
        if (payment.payment_value > this.totals.unpaid) {
          const cambio =
            parseFloat(payment.payment_value) - parseFloat(this.totals.unpaid);

          // Pago principal
          newPayment = {
            payment_concept: pay_mode.valor,
            payment_code: pay_mode.codigo,
            payment_reference: payment.payment_reference || "EFECTIVO",
            payment_value: this.totals.unpaid,
          };
          this.payments.push({ ...newPayment });

          // Cambio
          const cambioPayment = {
            payment_concept: "CAMBIO",
            payment_code: "01",
            payment_reference: `Cambio ${this.formatCurrency(cambio)}`,
            payment_value: 0,
          };
          this.payments.push({ ...cambioPayment });

          console.log("✅ Pago en efectivo con cambio:", { newPayment, cambioPayment });
        } else {
          // Pago exacto o parcial en efectivo
          newPayment = {
            payment_concept: pay_mode.valor,
            payment_code: pay_mode.codigo,
            payment_reference: payment.payment_reference || "EFECTIVO",
            payment_value: parseFloat(payment.payment_value),
          };
          this.payments.push({ ...newPayment });

          console.log("✅ Pago en efectivo:", newPayment);
        }
      } else {
        // Otros métodos de pago
        if (payment.payment_value <= this.totals.unpaid) {
          newPayment = {
            payment_concept: pay_mode.valor,
            payment_code: pay_mode.codigo,
            payment_reference: payment.payment_reference,
            payment_value: parseFloat(payment.payment_value),
          };
          this.payments.push({ ...newPayment });

          console.log("✅ Pago con otro método:", newPayment);
        } else {
          console.error("❌ Valor excede el monto pendiente");
          this.$store.commit("setSnackbar", {
            text: "Error: El valor excede el monto pendiente",
            color: "error",
            timeout: 3000,
          });
          return;
        }
      }

      console.log("📋 Pagos actuales:", this.payments);

      // Actualizar totales
      this.updateTotal();

      console.log("💰 Totales actualizados:", this.totals);

      // Mostrar mensaje de confirmación
      this.$store.commit("setSnackbar", {
        text: `Pago registrado: ${this.formatCurrency(payment.payment_value)}`,
        color: "success",
        timeout: 2000,
      });
    },

    fastPayment() {
      this.vendor = this.vendors[0].codigo;
      const pay = {
        payment_concept: "EFECTIVO",
        payment_code: "01",
        payment_reference: "PAGO RAPIDO",
        payment_value: this.totals.unpaid,
      };
      this.payments.push({ ...pay });
      this.updateTotal();
    },

    // Totales
    updateTotal() {
      this.totals.qty = 0;
      this.totals.total = 0;
      this.totals.tax = 0;
      this.totals.paid = 0;
      this.totals.unpaid = 0;

      this.cart.forEach((itm) => {
        this.totals.qty += parseFloat(itm.cantidad);
        this.totals.total += parseFloat(itm.cantidad) * parseFloat(itm.precio);
        this.totals.tax +=
          (parseFloat(itm.cantidad) * parseFloat(itm.precio) * parseFloat(itm.tax)) / 100;
      });

      if (this.bags > 0) {
        this.totals.total += this.bags * 0.1; // 10 céntimos por bolsa en España
      }

      this.payments.forEach((itm) => {
        if (itm.payment_code !== "00") {
          this.totals.paid += parseFloat(itm.payment_value);
        }
      });

      this.totals.unpaid = this.totals.total - this.totals.paid;
      this.payment.payment_value = this.totals.unpaid;

      // ✅ VALIDACIÓN MEJORADA: Solo procesar automáticamente si todo está completo
      if (this.totals.unpaid === 0 && this.totals.total > 0) {
        this.payment_dialogo = false;

        // Validar que el documento esté completamente listo antes de enviar
        if (this.isDocumentReadyToSubmit()) {
          console.log("✅ Documento completo, enviando automáticamente...");
          this.save_invoice();
        } else {
          console.log("⚠️ Documento pagado pero faltan validaciones");
          this.showDocumentValidationMessage();
        }
      }
    },

    // Validaciones
    validate_invoice() {
      // Validaciones básicas
      return this.totals.total <= 0 || !this.vendor;
    },

    // ✅ NUEVA: Validar que el documento esté completo para envío automático
    isDocumentReadyToSubmit() {
      console.log("🔍 Validando si documento está listo para envío...");

      // 1. Debe tener productos y estar totalmente pagado
      if (this.totals.total <= 0 || this.totals.unpaid > 0) {
        console.log("❌ No hay productos o falta pago");
        return false;
      }

      // 2. Debe tener vendedor
      if (!this.vendor) {
        console.log("❌ Falta vendedor");
        return false;
      }

      // 3. Validar información del cliente según el tipo de documento
      if (this.doctype === "FC") {
        // Factura completa requiere datos del cliente
        if (this.esClienteGenerico) {
          console.log("❌ Factura completa requiere datos del cliente");
          return false;
        }

        if (
          !this.client.PartyName ||
          !this.client.PartyIdentification ||
          !this.client.typeid
        ) {
          console.log("❌ Datos incompletos del cliente para FC");
          return false;
        }
      }

      // 4. En España, validar límite de 400€ para clientes genéricos
      const countryCode = countryUtils.getCurrentCountryCode();
      if (countryCode !== "CO" && this.totals.total > 400 && this.esClienteGenerico) {
        console.log("❌ Importe > 400€ requiere identificar cliente");
        return false;
      }

      console.log("✅ Documento listo para envío");
      return true;
    },

    // ✅ NUEVA: Mostrar mensaje cuando el documento está pagado pero no validado
    showDocumentValidationMessage() {
      let message = "Documento pagado. ";

      if (!this.vendor) {
        message += "Falta seleccionar vendedor.";
      } else if (this.doctype === "FC" && this.esClienteGenerico) {
        message += "Complete los datos del cliente para Factura Completa.";
      } else if (this.totals.total > 400 && this.esClienteGenerico) {
        message += "Para importes > 400€ debe identificar al cliente.";
      } else {
        message += "Revise los datos antes de procesar.";
      }

      this.$store.commit("setSnackbar", {
        text: message,
        color: "warning",
        timeout: 5000,
      });
    },

    // ✅ NUEVA: Obtener color del botón según el estado
    getCheckoutButtonColor() {
      if (this.totals.unpaid === 0 && this.totals.total > 0) {
        return this.isDocumentReadyToSubmit() ? "success" : "warning";
      }
      return "primary";
    },

    // ✅ NUEVA: Obtener etiqueta del botón según el estado
    getCheckoutButtonLabel() {
      if (this.totals.unpaid === 0 && this.totals.total > 0) {
        return this.isDocumentReadyToSubmit() ? "PROCESAR" : "COMPLETAR Y PROCESAR";
      }
      return "TOTAL A PAGAR";
    },

    // ✅ NUEVA: Manejar click del botón principal
    handleCheckoutClick() {
      if (this.totals.unpaid === 0 && this.totals.total > 0) {
        if (this.isDocumentReadyToSubmit()) {
          this.save_invoice();
        } else {
          this.showDocumentValidationMessage();
        }
      } else {
        this.openCheckout();
      }
    },

    // Guardar factura
    save_invoice() {
      if (this.validate_invoice()) return;

      var invoice = {
        buyer: this.client,
        doc: {
          doc_type: this.doctype,
          doc_value: this.totals.paid,
          store: window.store.store_id,
          userId: window.profile.user_email,
          vendor: this.vendor,
        },
        items: this.cart,
        payments: this.payments,
        seller: window.seller,
        store: window.store.store_id,
      };

      this.loading_status = true;
      console.log("📝 Guardando factura:", invoice);
      webserver("post_invoice", invoice, (data) => {
        console.log("Factura guardada:", data);
        this.loading_status = false;
        this.item = { ...data };
        this.dialog = true;
        this.nInvoice = true;
        this.resetInvoice();
      });
    },

    // Reset
    resetInvoice() {
      this.cart = [];
      // Establecer Consumidor Final por defecto al resetear
      this.client = {
        ...this.clientesGenericos.consumidor,
        CityName: this.company.city_code || this.client.CityName,
      };
      this.tipoClienteSeleccionado = "consumidor";
      this.payment = createPayment();
      this.payments = [];
      this.bags = 0;
      this.discount = null;
      this.vendor = null;
      this.updateTotal();
      this.setSku();
    },

    refresh_view() {
      var e = this.item;
      var issudate = e.issuedate.split(" ");
      var doc = {
        store: e.store,
        issueDate: issudate[0],
        did: e.doc_number,
      };
      this.loading_status = true;
      webserver("get_invoice_fe", doc, (data) => {
        this.loading_status = false;
        this.item = data;
        this.dialog = true;
      });
    },

    // Helpers
    // get_name_typeId(e) {
    //   var doc = this.id_lst.find((itm) => itm.code === e);
    //   return doc ? doc.name : "";
    // },

    get_name_city(e) {
      // Como municipalities fue eliminado, solo retornamos el código/ID
      return e || "";
    },

    containsOnlyNumbers(str) {
      return /^\d+$/.test(str);
    },

    filter: function (evt) {
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();

      if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    setSku() {
      setTimeout(() => {
        if (this.$refs.skuID) {
          this.$refs.skuID.focus();
        }
      }, 50);
    },
  },

  watch: {
    bags(newVal) {
      var idx = this.payments.findIndex((itm) => itm.payment_code === "00");
      if (newVal > 0) {
        if (idx === -1) {
          this.payments.push({
            payment_code: "00",
            payment_concept: "Impuesto bolsas plásticas",
            payment_reference: `${newVal} bolsas`,
            payment_value: 0.1 * newVal, // 10 céntimos por bolsa
          });
        } else {
          this.payments[idx].payment_value = 0.1 * newVal;
          this.payments[idx].payment_reference = `${newVal} bolsas`;
        }
      } else if (idx !== -1) {
        this.payments.splice(idx, 1);
      }
      this.updateTotal();
    },

    // ✅ ARREGLO: Watch mejorado para total
    "totals.total"(newVal, oldVal) {
      console.log("💰 Total cambió de", oldVal, "a", newVal);

      const countryCode = countryUtils.getCurrentCountryCode();

      if (countryCode !== "CO") {
        // 🇪🇸 ESPAÑA: Solo aplicar lógica de 400€ en España
        // Si cruzó el umbral de 400€, revalidar
        if ((oldVal <= 400 && newVal > 400) || (oldVal > 400 && newVal <= 400)) {
          this.$nextTick(() => {
            this.$forceUpdate();
            console.log("🔄 Umbral de 400€ cruzado, revalidando...");
          });
        }

        // Si el total supera 400€ y tiene cliente genérico, avisar
        if (newVal > 400 && this.esClienteGenerico && this.cart.length > 0) {
          this.$store.commit("setSnackbar", {
            text: "⚠️ Importe > 400€: Complete los datos del cliente",
            color: "warning",
            timeout: 5000,
          });
        }
      }
      // 🇨🇴 COLOMBIA: No hay restricciones por importe
    },

    // ✅ ARREGLO: Watch mejorado para cliente
    client: {
      handler(newClient, oldClient) {
        console.log("👤 Cliente cambió:", newClient);

        // Si cambió información crítica, forzar actualización
        if (
          oldClient &&
          (newClient.PartyName !== oldClient.PartyName ||
            newClient.PartyIdentification !== oldClient.PartyIdentification ||
            newClient.AddressLine !== oldClient.AddressLine)
        ) {
          this.$nextTick(() => {
            this.$forceUpdate();
            console.log(
              "🔄 Información crítica del cliente cambió, actualizando validaciones..."
            );
          });
        }
      },
      deep: true,
      immediate: true,
    },

    // ✅ ARREGLO: Watch para tipo de cliente
    tipoClienteSeleccionado: {
      handler(newTipo, oldTipo) {
        console.log("🏷️ Tipo de cliente cambió de", oldTipo, "a", newTipo);
        if (oldTipo && oldTipo !== newTipo) {
          this.$nextTick(() => {
            this.$forceUpdate();
          });
        }
      },
    },

    "client.PartyIdentification"(newVal) {
      if (!newVal) {
        this.limpiarValidacion();
      }
    },

    "client.typeid"(newVal, oldVal) {
      // Si el usuario cambia manualmente el tipo, respetarlo
      if (oldVal && this.client.PartyIdentification) {
        // Podríamos revalidar aquí si queremos
      }
    },
  },

  computed: {
    canOpenCheckout() {
      console.log("🔍 Evaluando canOpenCheckout...");

      // 1. Debe tener productos
      if (this.totals.total <= 0) {
        console.log("❌ No hay productos en el carrito");
        return false;
      }

      const countryCode = countryUtils.getCurrentCountryCode();

      if (countryCode === "CO") {
        // 🇨🇴 COLOMBIA: Todos los documentos son FE, menos restricciones
        console.log("✅ Colombia: Puede abrir checkout (FE siempre)");
        return true;
      } else {
        // 🇪🇸 ESPAÑA: Lógica original con límite 400€
        // 2. Para importes > 400€, verificar información del cliente
        if (this.totals.total > 400) {
          const isGeneric = this.esClienteGenerico;
          console.log("💰 Importe > 400€, cliente genérico:", isGeneric);

          if (isGeneric) {
            console.log("❌ Importe alto requiere información completa del cliente");
            return false;
          }
        }

        // 3. Si no es genérico pero requiere factura completa
        if (this.doctype === "FC" && this.esClienteGenerico) {
          console.log("❌ Factura completa requiere información del cliente");
          return false;
        }
      }

      console.log("✅ Puede abrir checkout");
      return true;
    },

    needsVendorSelection() {
      // Esta computed ya no se usa para bloquear el checkout
      // Solo es informativa
      return this.totals.total > 0 && !this.vendor;
    },

    needsCompleteClientInfo() {
      const countryCode = countryUtils.getCurrentCountryCode();

      if (countryCode === "CO") {
        // 🇨🇴 COLOMBIA: Menos restricciones
        return false;
      } else {
        // 🇪🇸 ESPAÑA: Lógica original
        // Para importes > 400€ y cliente genérico
        return this.totals.total > 400 && this.esClienteGenerico;
      }
    },

    hasValidationErrors() {
      // Verificar si hay errores críticos en las validaciones del cliente
      if (!this.needsClientInfoForValidation) return false;

      // Solo errores críticos que impiden abrir el checkout
      const criticalValidations = [0, 2, 3]; // Nombre, documento, tipo
      return criticalValidations.some(
        (index) => this.validations[index] && !this.validations[index].status
      );
    },

    needsClientInfoForValidation() {
      const countryCode = countryUtils.getCurrentCountryCode();

      if (countryCode === "CO") {
        // 🇨🇴 COLOMBIA: Solo para facturas completas específicas
        return this.doctype === "FC" || this.clienteSolicitaFactura;
      } else {
        // 🇪🇸 ESPAÑA: Lógica original
        // Determinar si se necesita información del cliente
        return (
          this.totals.total > 400 || this.doctype === "FC" || this.clienteSolicitaFactura
        );
      }
    },

    manualProductDiscount() {
      const price = parseFloat(this.manualProduct.precio) || 0;
      const qty = parseInt(this.manualProduct.cantidad) || 0;
      const discountPercent = parseFloat(this.manualProduct.descuento) || 0;
      return (price * qty * discountPercent) / 100;
    },

    manualProductSubtotal() {
      const price = parseFloat(this.manualProduct.precio) || 0;
      const qty = parseInt(this.manualProduct.cantidad) || 0;
      return price * qty - this.manualProductDiscount;
    },

    manualProductTax() {
      const subtotal = this.manualProductSubtotal;
      const taxRate = parseFloat(this.manualProduct.tax) || 0;
      return (subtotal * taxRate) / 100;
    },

    manualProductTotal() {
      return this.manualProductSubtotal + this.manualProductTax;
    },
    subtotal() {
      return this.cart.reduce((acc, item) => {
        return acc + item.precio * item.cantidad;
      }, 0);
    },
    puedeSerFacturaSimplificada() {
      // 🇨🇴 COLOMBIA: Todos los documentos son FE, no hay facturas simplificadas
      const countryCode = countryUtils.getCurrentCountryCode();
      if (countryCode === "CO") {
        return false; // En Colombia no existen facturas simplificadas
      }
      // Para otros países mantener la lógica española
      return this.totals.total <= 400;
    },

    esClienteGenerico() {
      const countryCode = countryUtils.getCurrentCountryCode();

      if (countryCode === "CO") {
        // 🇨🇴 COLOMBIA: IDs genéricos diferentes
        const genericIds = ["222222222222", "11111111", "", null, undefined];
        const genericNames = [
          "CONSUMIDOR FINAL",
          "CLIENTE CONTADO",
          "CLIENTE EXTRANJERO",
        ];

        const hasGenericId = genericIds.includes(this.client.PartyIdentification);
        const hasGenericName = genericNames.includes(this.client.PartyName);

        // Si tiene información completa, NO es genérico
        const hasCompleteInfo =
          this.client.PartyName &&
          this.client.PartyName.trim() !== "" &&
          !genericNames.includes(this.client.PartyName) &&
          this.client.PartyIdentification &&
          this.client.PartyIdentification.trim() !== "" &&
          !genericIds.includes(this.client.PartyIdentification) &&
          this.client.AddressLine &&
          this.client.AddressLine.trim() !== "" &&
          this.validarDocumentoColombia(
            this.client.PartyIdentification,
            this.client.typeid
          ).valido;

        return !hasCompleteInfo && (hasGenericId || hasGenericName);
      } else {
        // ✅ ESPAÑA: Lógica original
        const genericIds = ["99999999R", "X0000000T", "", null, undefined];
        const genericNames = [
          "CONSUMIDOR FINAL",
          "CLIENTE CONTADO",
          "CLIENTE EXTRANJERO",
        ];

        const hasGenericId = genericIds.includes(this.client.PartyIdentification);
        const hasGenericName = genericNames.includes(this.client.PartyName);

        // Si tiene información completa, NO es genérico aunque tenga un ID genérico
        const hasCompleteInfo =
          this.client.PartyName &&
          this.client.PartyName.trim() !== "" &&
          !genericNames.includes(this.client.PartyName) &&
          this.client.PartyIdentification &&
          this.client.PartyIdentification.trim() !== "" &&
          !genericIds.includes(this.client.PartyIdentification) &&
          this.client.AddressLine &&
          this.client.AddressLine.trim() !== "" &&
          this.validarDocumentoEspanol(this.client.PartyIdentification).valido;

        console.log("🔍 Cliente genérico check:", {
          hasGenericId,
          hasGenericName,
          hasCompleteInfo,
          client: this.client,
        });

        return !hasCompleteInfo && (hasGenericId || hasGenericName);
      }
    },

    tipoClienteChip() {
      if (this.client.PartyName === "CONSUMIDOR FINAL") return "Consumidor Final";
      if (this.client.PartyName === "CLIENTE CONTADO") return "Contado";
      if (this.client.PartyName === "CLIENTE EXTRANJERO") return "Extranjero";
      return "";
    },

    tipoFacturaAlert() {
      const countryCode = countryUtils.getCurrentCountryCode();

      if (countryCode === "CO") {
        // 🇨🇴 COLOMBIA: Todos los documentos son FE
        if (this.tipoClienteSeleccionado === "consumidor") {
          return {
            type: "info",
            title: "Se generará: FACTURA ELECTRÓNICA",
            message: "Consumidor Final - Válida para cualquier importe",
          };
        } else if (this.tipoClienteSeleccionado === "contado") {
          return {
            type: "info",
            title: "Se generará: FACTURA ELECTRÓNICA",
            message: "Cliente Contado - Con identificación genérica",
          };
        } else if (this.tipoClienteSeleccionado === "identificado") {
          return {
            type: "success",
            title: "Se generará: FACTURA ELECTRÓNICA",
            message: "Cliente identificado - Con todos los datos fiscales",
          };
        }
      } else {
        // 🇪🇸 ESPAÑA: Lógica original
        if (this.totals.total <= 400) {
          if (this.tipoClienteSeleccionado === "consumidor") {
            return {
              type: "info",
              title: "Se generará: FACTURA SIMPLIFICADA",
              message: "Sin datos de cliente. Válida para importes ≤ 400€",
            };
          } else if (this.tipoClienteSeleccionado === "contado") {
            return {
              type: "info",
              title: "Se generará: FACTURA SIMPLIFICADA",
              message: "Con identificación genérica. El cliente NO podrá deducir IVA",
            };
          }
        }

        if (this.totals.total > 400 && this.tipoClienteSeleccionado !== "identificado") {
          return {
            type: "warning",
            title: "ATENCIÓN: Importe > 400€",
            message:
              "Se requiere identificación completa del cliente para factura completa",
          };
        }

        return {
          type: "success",
          title: "Se generará: FACTURA COMPLETA",
          message:
            "Con todos los datos fiscales. El cliente podrá deducir IVA si procede",
        };
      }

      return {
        type: "success",
        title: "Se generará: FACTURA ELECTRÓNICA",
        message: "Documento fiscal válido",
      };
    },

    // Para el componente de Checkout
    requiereIdentificacionCompleta() {
      return (
        this.totals.total > 400 ||
        this.doctype === "invoice" ||
        this.client.typeid === "A" ||
        this.client.typeid === "B"
      );
    },
  },
};
</script>

<style scoped>
/* Tabla con altura fija */
::v-deep .v-data-table__wrapper {
  overflow-y: auto !important;
}

/* Headers compactos */
::v-deep .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 0.75rem !important;
  font-weight: 600 !important;
  padding: 8px !important;
}

/* Celdas compactas */
::v-deep .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  padding: 8px !important;
}

/* Scroll suave */
.overflow-y-auto {
  scrollbar-width: thin;
  scrollbar-color: #e0e0e0 #fafafa;
}

.overflow-y-auto::-webkit-scrollbar {
  width: 6px;
}

.overflow-y-auto::-webkit-scrollbar-track {
  background: #fafafa;
}

.overflow-y-auto::-webkit-scrollbar-thumb {
  background-color: #e0e0e0;
  border-radius: 3px;
}

/* Altura completa */
.d-flex.flex-column {
  display: flex;
  flex-direction: column;
}

.flex-grow-1 {
  flex-grow: 1;
}

/* Tabs sin padding extra */
::v-deep .v-tabs-items {
  background-color: transparent !important;
}

/* Contenedor scrollable del carrito */
.cart-scroll-container {
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100vh -400px); /* Altura calculada: viewport - header - toolbar - footer */
  max-height: calc(100vh - 400px);
}

/* Estilos para items del carrito */
.cart-item {
  border-bottom: 1px solid #e0e0e0;
  cursor: pointer;
  transition: background-color 0.2s;
}

.cart-item:hover {
  background-color: #f5f5f5;
}

/* Scroll personalizado */
.cart-scroll-container::-webkit-scrollbar {
  width: 8px;
}

.cart-scroll-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.cart-scroll-container::-webkit-scrollbar-thumb {
  background: #bdbdbd;
  border-radius: 4px;
}

.cart-scroll-container::-webkit-scrollbar-thumb:hover {
  background: #9e9e9e;
}
</style>
